var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "monitoring" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "monitoring__header" }, [
          _c("h2", [_vm._v("Мониторинг")]),
          _vm._v(" "),
          _vm.allCountUnseen >= 0 && _vm.allCountTotal >= 0
            ? _c("p", [
                _vm._v(
                  "Кол-во новых изменений " +
                    _vm._s(_vm.allCountUnseen) +
                    " из " +
                    _vm._s(_vm.allCountTotal)
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "monitoring__sidebar" }, [
          _c(
            "div",
            {
              staticClass: "monitoring__sidebar_button",
              on: {
                click: function ($event) {
                  _vm.showAddMonitoringModal = !_vm.showAddMonitoringModal
                },
              },
            },
            [
              _c("i", { staticClass: "lnr lnr-file-add" }),
              _vm._v("Добавить в мониторинг"),
            ]
          ),
          _vm._v(" "),
          _vm.showAddMonitoringModal
            ? _c("div", [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.ogrnUploadList,
                      expression: "ogrnUploadList",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder:
                      "Загрузка ОГРН кодов для добавления, каждый с новой строки.\n\nВам доступно " +
                      (_vm.monitoringLimit - _vm.allCompaniesOgrns) +
                      " из " +
                      _vm.monitoringLimit,
                  },
                  domProps: { value: _vm.ogrnUploadList },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.ogrnUploadList = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "uk-button uk-button-primary",
                    on: { click: _vm.addMultipleOgrns },
                  },
                  [_vm._v("Добавить в мониторинг")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "monitoring__sidebar_button",
              on: {
                click: function ($event) {
                  return _vm.downloadXLSX(null)
                },
              },
            },
            [
              _c("i", { staticClass: "lnr lnr-download" }),
              _vm._v("Скачать таблицу .xlsx"),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "monitoring__sidebar-category" }, [
            _c("div", { staticClass: "monitoring__sidebar-category-header" }, [
              _vm._v("Все категории"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "monitoring__sidebar-category-switch-btn",
                on: {
                  click: function ($event) {
                    return _vm.selectCategory(0)
                  },
                },
              },
              [_vm._v("Показать все")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "monitoring__sidebar-category-switch-btn": true,
                  "monitoring__sidebar-category-switch-btn_active":
                    _vm.selectedCategory == 1,
                },
                on: {
                  click: function ($event) {
                    return _vm.selectCategory(1)
                  },
                },
              },
              [_c("i", { staticClass: "far fa-eye" }), _vm._v(" Без категории")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "monitoring__sidebar-category-switch-btn": true,
                  "monitoring__sidebar-category-switch-btn_active":
                    _vm.selectedCategory == 2,
                },
                on: {
                  click: function ($event) {
                    return _vm.selectCategory(2)
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-people-carry" }),
                _vm._v(" Поставщик"),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "monitoring__sidebar-category-switch-btn": true,
                  "monitoring__sidebar-category-switch-btn_active":
                    _vm.selectedCategory == 7,
                },
                on: {
                  click: function ($event) {
                    return _vm.selectCategory(7)
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-user-slash" }),
                _vm._v(" Недобросовестный поставщик "),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "monitoring__sidebar-category-switch-btn": true,
                  "monitoring__sidebar-category-switch-btn_active":
                    _vm.selectedCategory == 4,
                },
                on: {
                  click: function ($event) {
                    return _vm.selectCategory(4)
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-dolly-flatbed" }),
                _vm._v(" Клиент"),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "monitoring__sidebar-category-switch-btn": true,
                  "monitoring__sidebar-category-switch-btn_active":
                    _vm.selectedCategory == 5,
                },
                on: {
                  click: function ($event) {
                    return _vm.selectCategory(5)
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-hand-holding-usd" }),
                _vm._v(" Должник"),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "monitoring__sidebar-category-switch-btn": true,
                  "monitoring__sidebar-category-switch-btn_active":
                    _vm.selectedCategory == 3,
                },
                on: {
                  click: function ($event) {
                    return _vm.selectCategory(3)
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-ghost" }), _vm._v(" Конкурент")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "monitoring__sidebar-category-switch-btn": true,
                  "monitoring__sidebar-category-switch-btn_active":
                    _vm.selectedCategory == 8,
                },
                on: {
                  click: function ($event) {
                    return _vm.selectCategory(8)
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-sitemap" }),
                _vm._v(" Аффилированная структура"),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "monitoring__sidebar-category-switch-btn": true,
                  "monitoring__sidebar-category-switch-btn_active":
                    _vm.selectedCategory == 6,
                },
                on: {
                  click: function ($event) {
                    return _vm.selectCategory(6)
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-crown" }), _vm._v(" VIP")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "monitoring__content" },
          [
            _c("div", { staticClass: "monitoring__content-search-block" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.listFilterQuery,
                    expression: "listFilterQuery",
                  },
                ],
                staticClass: "monitoring__content-search",
                attrs: { value: "", placeholder: "Поиск по наименованию" },
                domProps: { value: _vm.listFilterQuery },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.listFilterQuery = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.listFilterQuery
                ? _c("i", {
                    staticClass: "lnr lnr-cross",
                    on: {
                      click: function ($event) {
                        _vm.listFilterQuery = ""
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.loading
              ? _c("shestirenkaLoader")
              : _vm.monitoringCompanies.length
              ? [
                  _vm.pagination
                    ? _c("pagination", {
                        attrs: {
                          pagination: _vm.pagination,
                          onTurnPageCallBack: _vm.getCompanies,
                          showRowsPerPageSelection: true,
                          rows_on_page: _vm.monitoringCompanies.length,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("table", { staticClass: "monitoring__content-table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        { staticClass: "monitoring__content-table-header" },
                        [
                          _c("th", [
                            _vm.selectedList.length == 0
                              ? _c("i", {
                                  staticClass: "far fa-square",
                                  attrs: { "aria-hidden": "true" },
                                  on: { click: _vm.fillSelectedList },
                                })
                              : _vm.selectedList.length > 0 &&
                                _vm.selectedList.length !=
                                  _vm.monitoringCompanies.length
                              ? _c("i", {
                                  staticClass: "fas fa-minus-square",
                                  attrs: { "aria-hidden": "true" },
                                  on: { click: _vm.clearSelectedList },
                                })
                              : _vm.selectedList.length > 0 &&
                                _vm.selectedList.length ==
                                  _vm.monitoringCompanies.length
                              ? _c("i", {
                                  staticClass: "fas fa-check-square",
                                  attrs: { "aria-hidden": "true" },
                                  on: { click: _vm.clearSelectedList },
                                })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass:
                                "monitoring__content-table-header-category",
                            },
                            [
                              _vm.selectedList.length
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "blue-red-hover-text",
                                      on: {
                                        click: function ($event) {
                                          _vm.showChangeCategoryMenu =
                                            !_vm.showChangeCategoryMenu
                                        },
                                      },
                                    },
                                    [
                                      _vm._v("Изменить "),
                                      _c("i", {
                                        staticClass: "lnr lnr-chevron-down",
                                      }),
                                    ]
                                  )
                                : _c("span", [_vm._v("Категория")]),
                              _vm._v(" "),
                              _vm.showChangeCategoryMenu &&
                              _vm.selectedList.length
                                ? _c("ul", [
                                    _c(
                                      "li",
                                      {
                                        staticClass: "blue-red-hover-text",
                                        on: {
                                          click: function ($event) {
                                            return _vm.setSelectedComapniesCategory(
                                              1
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", { staticClass: "far fa-eye" }),
                                        _vm._v(" Без категории"),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "blue-red-hover-text",
                                        on: {
                                          click: function ($event) {
                                            return _vm.setSelectedComapniesCategory(
                                              2
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-people-carry",
                                        }),
                                        _vm._v(" Поставщик"),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "blue-red-hover-text",
                                        on: {
                                          click: function ($event) {
                                            return _vm.setSelectedComapniesCategory(
                                              7
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-user-slash",
                                        }),
                                        _vm._v(" Недобросовестный поставщик"),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "blue-red-hover-text",
                                        on: {
                                          click: function ($event) {
                                            return _vm.setSelectedComapniesCategory(
                                              4
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-dolly-flatbed",
                                        }),
                                        _vm._v(" Клиент"),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "blue-red-hover-text",
                                        on: {
                                          click: function ($event) {
                                            return _vm.setSelectedComapniesCategory(
                                              3
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-ghost",
                                        }),
                                        _vm._v(" Конкурент"),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "blue-red-hover-text",
                                        on: {
                                          click: function ($event) {
                                            return _vm.setSelectedComapniesCategory(
                                              5
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-hand-holding-usd",
                                        }),
                                        _vm._v(" Должник"),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "blue-red-hover-text",
                                        on: {
                                          click: function ($event) {
                                            return _vm.setSelectedComapniesCategory(
                                              8
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-sitemap",
                                        }),
                                        _vm._v(" Аффилированная структура"),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "blue-red-hover-text",
                                        on: {
                                          click: function ($event) {
                                            return _vm.setSelectedComapniesCategory(
                                              6
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-crown",
                                        }),
                                        _vm._v(" VIP"),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c("th", [
                            _vm.selectedList.length
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "blue-red-hover-text",
                                    on: { click: _vm.deleteCompanies },
                                  },
                                  [_vm._v("Удалить выбранное из мониторинга")]
                                )
                              : _c("span", [_vm._v("Наименование")]),
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v("Дата постановки "),
                            _c("br"),
                            _vm._v(" на мониторинг"),
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _c("div", [_vm._v("Последнее изменение")]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass:
                                "monitoring__content-table-header-changes",
                            },
                            [
                              _vm.selectedList.length
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "blue-red-hover-text",
                                        on: { click: _vm.watchCompanies },
                                      },
                                      [
                                        _vm._v("Отметить как "),
                                        _c("br"),
                                        _vm._v(" прочитанное"),
                                      ]
                                    ),
                                  ]
                                : [
                                    _c("div", [_vm._v("Кол-во изменений")]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { "font-size": "12px" } },
                                      [
                                        _vm._v(
                                          "(" +
                                            _vm._s(_vm.countUnseen) +
                                            " из " +
                                            _vm._s(_vm.countTotal) +
                                            ")"
                                        ),
                                      ]
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.monitoringCompanies, function (e, i) {
                        return _c(
                          "tr",
                          {
                            key: i,
                            staticClass: "monitoring__content-table-item",
                          },
                          [
                            _c("td", [
                              _vm.selectedList.includes(e.company_id)
                                ? _c("i", {
                                    staticClass: "fas fa-check-square",
                                    attrs: { "aria-hidden": "true" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeFromSelectedList(
                                          e.company_id
                                        )
                                      },
                                    },
                                  })
                                : _c("i", {
                                    staticClass: "far fa-square",
                                    attrs: { "aria-hidden": "true" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addToSelectedList(
                                          e.company_id
                                        )
                                      },
                                    },
                                  }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("i", {
                                  class: _vm.getCategoryIconClassName(
                                    e.category_id
                                  ),
                                  staticStyle: {
                                    "font-size": "18px",
                                    width: "auto",
                                    color: "#555",
                                  },
                                  attrs: {
                                    title: _vm.getCategory(e.category_id),
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "monitoring__content-table-item-name",
                              },
                              [
                                _c("div", [
                                  _c("span", [
                                    e.company_date_stop
                                      ? _c("i", {
                                          staticClass: "uk-icon-times-circle",
                                          staticStyle: { color: "#e74c3c" },
                                        })
                                      : _c("i", {
                                          staticClass: "uk-icon-check-circle",
                                          staticStyle: { color: "#2ecc71" },
                                        }),
                                  ]),
                                  _vm._v(" "),
                                  e.company_id
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "/company/" + e.company_id,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          e.company_name_short
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(e.company_name_short)
                                                ),
                                              ])
                                            : e.company_name_full
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(e.company_name_full)
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      )
                                    : _c("span", [
                                        e.company_name_short
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(e.company_name_short)
                                              ),
                                            ])
                                          : e.company_name_full
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(e.company_name_full)
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]),
                                ]),
                                _vm._v(" "),
                                _vm.getCategoriesListItemByOgrn(e.company_id)
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        _vm.getCategoriesListItemByOgrn(
                                          e.company_id
                                        ).categories,
                                        function (e, i) {
                                          return _c("span", { key: i }, [
                                            _c(
                                              "span",
                                              {
                                                style: _vm.categoryStyleColor(
                                                  e.id
                                                ),
                                              },
                                              [_vm._v(_vm._s(e.title))]
                                            ),
                                            _vm._v(
                                              " в " +
                                                _vm._s(e.groups.join(", ")) +
                                                ";\n                                    "
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [
                              e.started_at
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        new Date(
                                          e.started_at
                                        ).toLocaleDateString()
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    new Date(e.changed_at).toLocaleDateString()
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              e.change_type_title
                                ? _c("div", [
                                    _vm._v(_vm._s(e.change_type_title)),
                                  ])
                                : _c("div", [_vm._v("—")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "monitoring__content-table-item-changes",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "monitoring__content-table-item-changes-new",
                                  },
                                  [_vm._v("Новых " + _vm._s(e.count_unseen))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "monitoring__content-table-item-changes-all",
                                  },
                                  [_vm._v("Всего " + _vm._s(e.count_total))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "monitoring__content-table-item-changes-show",
                                    on: {
                                      click: function ($event) {
                                        _vm.showCompanyChanges(
                                          0,
                                          50,
                                          e.company_id,
                                          e.company_name_short
                                            ? e.company_name_short
                                            : e.company_name_full
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Показать")]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.pagination
                    ? _c("pagination", {
                        attrs: {
                          pagination: _vm.pagination,
                          onTurnPageCallBack: _vm.getCompanies,
                          showRowsPerPageSelection: true,
                          rows_on_page: _vm.monitoringCompanies.length,
                        },
                      })
                    : _vm._e(),
                ]
              : [
                  _c("h3", { staticStyle: { margin: "10px 0" } }, [
                    _vm._v("Компаний не найдено"),
                  ]),
                ],
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.showCompanyChangesModal
        ? _c(
            "modal",
            {
              attrs: {
                close: _vm.closeModalHandler,
                printButton: true,
                downloadButton: false,
              },
            },
            [
              _c(
                "span",
                { attrs: { slot: "modalHeader" }, slot: "modalHeader" },
                [
                  _vm._v("Список изменений "),
                  _c(
                    "a",
                    {
                      staticStyle: { border: "0" },
                      attrs: {
                        href: "/company/" + _vm.comapnyChangesOGRN,
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.comapnyChangesName))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { padding: "10px" },
                  attrs: { slot: "modalBody" },
                  slot: "modalBody",
                },
                [
                  _vm.companyChangesPagination
                    ? _c("pagination", {
                        attrs: {
                          pagination: _vm.companyChangesPagination,
                          onTurnPageCallBack: _vm.getCompanyChanges,
                          showRowsPerPageSelection: true,
                          rows_on_page: _vm.companyChangesData.length,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("table", { staticClass: "simple-table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Изменение")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Дата обновления информации")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Старые данные")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Новые данные")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.companyChangesData, function (e, i) {
                        return _c("tr", { key: i }, [
                          _c("td", { staticStyle: { "font-weight": "400" } }, [
                            _vm._v(_vm._s(e.change_type_title)),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.format_time(e.change_date))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              e.data_old &&
                              e.data_old.length &&
                              e.data_old.length > 0 &&
                              e.data_old[0] != null
                                ? _vm._l(e.data_old, function (e, i) {
                                    return _c(
                                      "div",
                                      { key: i },
                                      [
                                        e.title
                                          ? _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "font-weight": "400",
                                                  margin: "15px 0",
                                                },
                                              },
                                              [_vm._v(_vm._s(e.title))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        e.value
                                          ? _c("p", [_vm._v(_vm._s(e.value))])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        e.attributes && e.attributes.length
                                          ? _vm._l(
                                              e.attributes,
                                              function (e, i) {
                                                return _c(
                                                  "p",
                                                  {
                                                    key: i,
                                                    staticStyle: {
                                                      margin: "0",
                                                    },
                                                  },
                                                  [
                                                    e.title
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(e.title) +
                                                              ":"
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    e.value
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(e.value)
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  })
                                : [_vm._v("—")],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              e.data_new &&
                              e.data_new.length &&
                              e.data_new.length > 0 &&
                              e.data_new[0] != null
                                ? [
                                    e.change_type == "/КадНовый" &&
                                    e.data_new[0].id
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "http://kad.arbitr.ru/Card/" +
                                                  e.data_new[0].id,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(e.data_new[0].number)
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._l(e.data_new, function (e, i) {
                                          return _c(
                                            "div",
                                            { key: i },
                                            [
                                              e.title
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "400",
                                                        margin: "15px 0",
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(e.title))]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              e.value
                                                ? _c("p", [
                                                    _vm._v(_vm._s(e.value)),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              e.attributes &&
                                              e.attributes.length
                                                ? _vm._l(
                                                    e.attributes,
                                                    function (e, i) {
                                                      return _c(
                                                        "p",
                                                        {
                                                          key: i,
                                                          staticStyle: {
                                                            margin: "0",
                                                          },
                                                        },
                                                        [
                                                          e.title
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    e.title
                                                                  ) + ":"
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          e.value
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    e.value
                                                                  )
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        }),
                                  ]
                                : [_vm._v("—")],
                            ],
                            2
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.companyChangesPagination
                    ? _c("pagination", {
                        attrs: {
                          pagination: _vm.companyChangesPagination,
                          onTurnPageCallBack: _vm.getCompanyChanges,
                          showRowsPerPageSelection: true,
                          rows_on_page: _vm.companyChangesData.length,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "uk-button",
                  attrs: { slot: "modalFooter" },
                  on: {
                    click: function ($event) {
                      return _vm.downloadXLSX(_vm.comapnyChangesOGRN)
                    },
                  },
                  slot: "modalFooter",
                },
                [
                  _c("i", { staticClass: "lnr lnr-download" }),
                  _vm._v(" Сохранить в .xlsx"),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }